import { useCrewsQuery } from "../../crew/useCrewsQuery";
import { useTranslation } from "react-i18next";

interface Props {
  currentCrewIdentifier: string | undefined;
}

export function CrewTitle(props: Props) {
  const { t } = useTranslation();
  const { crews } = useCrewsQuery();

  if (props.currentCrewIdentifier === undefined)
    return <>{t("crew.dialog.private")}</>;
  else if (!crews) return <></>;
  else
    return (
      <>
        {crews.find((p) => p.identifier === props.currentCrewIdentifier)?.title}
      </>
    );
}
